export const formatDate = (date: Date) => {
  if (!date || Number.isNaN(date.getTime())) {
    return undefined;
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${month}/${day}/${year}`;
};

/** Safe label for API date strings; returns undefined when missing/invalid. */
export const formatDateLabel = (
  value?: string | Date | null,
): string | undefined => {
  if (value == null || value === "") {
    return undefined;
  }
  const date = value instanceof Date ? value : new Date(value);
  return formatDate(date);
};
